// General
import "./education-filter.scss";
import { useEffect } from "react";
// Services
import { useLazyGetJourneyQuestionsQuery } from "../../../../../services/data.service";
// Static Data
import searchConst from "../../../../../const/searchConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateEducationData,
  updateEducationSelected,
} from "../../../../../redux/store/searchFilterStore";
import { updateEducationFilterDialog } from "../../../../../redux/store/dialogStore";
// Material UI
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Components
import Spinner from "../../spinner/spinner";

const EducationFilter = (props) => {
  const { type, enableTitle = true } = props;

  // API variables
  const [
    getJourneyQuestions,
    {
      data: getJourneyQuestionsData,
      error: getJourneyQuestionsErrorData,
      isFetching: getJourneyQuestionsFetching,
      isLoading: getJourneyQuestionsLoading,
      isSuccess: getJourneyQuestionsSuccess,
      isError: getJourneyQuestionsError,
    },
  ] = useLazyGetJourneyQuestionsQuery();

  // Redux variables
  const educationData = useSelector(
    (state) => state.searchFilter.educationData
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Lifecycle | Mounted
  useEffect(() => {
    getJourneyQuestions(null, true);
  }, []);

  // Lifecycle | Check for update | getJourneyQuestions API Response
  useEffect(() => {
    if (getJourneyQuestionsFetching || getJourneyQuestionsLoading) {
    } else if (getJourneyQuestionsSuccess) {
      if (educationData?.length > 0) return;

      let tempEducationData = getEducationData()?.map((item) => ({
        ...item,
        isSelected: false,
      }));
      dispatch(updateEducationData(tempEducationData));
    } else if (getJourneyQuestionsError) {
    }
  }, [
    getJourneyQuestionsFetching,
    getJourneyQuestionsLoading,
    getJourneyQuestionsSuccess,
    getJourneyQuestionsError,
  ]);

  // Lifecycle | Check for update | educationData
  useEffect(() => {
    dispatch(updateEducationSelected(getSelectedEducation()));
  }, [educationData]);

  // Event Handlers | MUI Checkbox
  const onCheckboxChange = (id) => (event) => {
    const updatedEducationData = educationData?.map((item) =>
      item.id === id ? { ...item, isSelected: event.target.checked } : item
    );
    dispatch(updateEducationData(updatedEducationData));
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateEducationFilterDialog(false));
  };

  // Utility Functions
  const getEducationData = () => {
    return getJourneyQuestionsData?.selections?.find(
      (item) => item?.category === "education"
    )?.selections;
  };
  const getSelectedEducation = () => {
    return educationData?.filter((item) => item.isSelected);
  };

  return (
    <div id="education-filter-shared-component">
      {enableTitle && (
        <div className="dialog-header">
          <div className="title">{t("filter.education")}</div>

          <div className="close-button-container">
            <CloseIcon className="close-button" onClick={onCloseDialog} />
          </div>
        </div>
      )}

      <div className="padding-container">
        {educationData?.length > 0 ? (
          <div
            className={`checkbox-container ${
              type === searchConst.searchFilterType.full ? "flexwrap" : ""
            }`}
          >
            {educationData?.map((education, index) => (
              <FormGroup className="checkbox" key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      className={`custom-checkbox ${
                        type === searchConst.searchFilterType.full
                          ? "custom-checkbox-no-padding"
                          : ""
                      }`}
                      size={
                        type === searchConst.searchFilterType.full
                          ? "small"
                          : "medium"
                      }
                      checked={education?.isSelected}
                      onChange={onCheckboxChange(education?.id)}
                    />
                  }
                  label={
                    <span
                      className={
                        type === searchConst.searchFilterType.full
                          ? "checkbox-font"
                          : ""
                      }
                    >
                      {education?.display_locale}
                    </span>
                  }
                />
              </FormGroup>
            ))}
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default EducationFilter;
